import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import MultilineChartOutlinedIcon from '@mui/icons-material/MultilineChartOutlined';

export const BannerInfoCalificaciones = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: { xs: 3, md: 4 },
        backgroundColor: '#F8F7FA', // Color de fondo muy suave
        borderRadius: 3,
        border: '1px solid #EAEAFF',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          mb: 4,
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, flex: 1, minWidth: '300px' }}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: '50%',
              backgroundColor: '#E8E7FD',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <AutoAwesomeIcon sx={{ color: '#696CFF', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}
            >
              ¿Cómo funciona la gestión de calificaciones?
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500, maxWidth: '80%' }}
            >
              Revisa el feedback dejado por tus huéspedes en tiempo real, aplica filtros detallados
              y toma acción sobre los casos reportados.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <FilterAltOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}
              >
                Búsqueda Avanzada
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                Filtra por fechas, agentes y cantidad de eventos.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <MarkEmailReadOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}
              >
                Seguimiento de Casos
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                Registra soluciones y reporta el progreso al cliente.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <MultilineChartOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}
              >
                Estadísticas Generales
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                Monitorea el comportamiento mensual y el NPS global.
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};
